export default "__VITE_ASSET__CouyYrtK__"